import {
  Burger,
  Container,
  Group,
  useComputedColorScheme,
} from "@mantine/core";
import classes from "./HeaderMenu.module.css";
import UserAvatar from "../../Boilerplate/_Shared/UserAvatar";
import { useStore } from "./store";
import { Link, useLocation } from "wouter";
import { getTenantProfile } from "./api";
import { useEffect } from "react";
import brandkarma from "./brandkarma.png";
import BrandKarmaLogo from "./_Shared/BrandKarmaLogo";
import { BrandSwitcher } from "./Brands/BrandSwitcher";
import ActivityIndicator from "./Jobs/ActivityIndicator";

export function HeaderMenu({ opened, toggle }) {
  const [, setLocation] = useLocation();
  const profile = useStore((state) => state.profile);
  const setTenantProfile = useStore((state) => state.setTenantProfile);
  const authToken = useStore((state) => state.authToken);
  const isDarkMode = useComputedColorScheme() === "dark";

  useEffect(() => {
    if (authToken) {
      getTenantProfile().then((data) => {
        setTenantProfile(data);
      });
    }
  }, [profile, authToken]);

  return (
    <header className={classes.header}>
      <Container fluid px="md">
        <div className={classes.inner}>
          <Group gap="sm">
            <Burger
              opened={opened}
              onClick={toggle}
              size="sm"
              hiddenFrom="sm"
            />

            {profile && <BrandSwitcher />}
          </Group>

          <Group gap="sm" visibleFrom="md">
            <Link href="/" className={classes.logoGroup}>
              <BrandKarmaLogo size={28} />
              <img
                className={classes.logotype}
                style={{ filter: isDarkMode ? "invert(0.95)" : "none" }}
                src={brandkarma}
                alt="BrandKarma"
                height={28}
              />
            </Link>
          </Group>

          {profile && (
            <Group gap="md">
              <ActivityIndicator />
              <Group
                style={{ cursor: "pointer" }}
                onClick={(event) => {
                  event.preventDefault();
                  setLocation("/profile");
                }}
              >
                <UserAvatar profile={profile} />
              </Group>
            </Group>
          )}
        </div>
      </Container>
    </header>
  );
}
